import React, { useRef } from "react";
import { BannerSection,RetreatCard, Button, DynamicVideoCarousel, Header, TransformSection } from "../../../components/template";
import { useNavigate } from 'react-router-dom';

const HomePage = () => {
  const detailsRef = useRef(null);
  const details = () => {
    if (detailsRef.current) {
      detailsRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };
  const navigate = useNavigate();

  const bannerp="🌱 Great mix of Learning, Bonding, and Fun - Nature Hikes, Games, Music";
        
  const heading = "What's Unique About INNERGISE";
  const features = [
    { icon: "🌿", text: "Profound Self-Discovery – Unlock clarity, confidence, and emotional resilience" },
    { icon: "🧠", text: "Deep Rejuvenation of Body & Mind – Balance wellness with fun and adventure" },
    { icon: "🧘", text: "Proven Practical Techniques – Yoga, Ayurveda, Meditation, and Positive Psychology" },
       { icon: "🏞️", text: " Adventure & Joy – Nature hikes, soulful bonfires & interactive games" }
  ];
  const transformHeading = "How Will It Transform You? ";
  const transformParagraph = "🌿 No more temporary fixes—this retreat creates lasting transformation.";
  const transformImage = "/assets/synnergise/sincl.jpg";
  const transformPoints = [
    <>
      <b>Physical Vitality –</b> Strengthen immunity, improve digestion & boost energy
    </>,
    <>
      <b>Mental Clarity –</b> Remove brain fog, improve focus & cultivate peace
    </>,
    <>
      <b>Emotional Strength –</b> Manage stress, break negative cycles & feel lighter
    </>,
    <>
      <b>Life Alignment –</b> Walk away with tools for lasting joy & balance
    </>
  ];
  const ticons=["🌞","🌞","🌞","🌞","🌞"]
  
  const icons = ["✨", "🧘‍♂️", "🏆"]; 
  const testimonalVideos = [
    'https://www.youtube.com/embed/yz4INHZkJNI', 
    'https://www.youtube.com/embed/0E8hm2fdxCs', 
    'https://www.youtube.com/embed/cHuh-cGuYmg', 
  ];
  const mediaItems = [
    { type: "youtube", src: "https://www.youtube.com/embed/k7VaKfHJUeA" }, 
{ type: "image", src: "/assets/synnergise/10.jpg" },
    { type: "image", src: "/assets/synnergise/7.jpg" },
{ type: "image", src: "/assets/synnergise/1.jpg" },
    { type: "youtube", src: "https://www.youtube.com/embed/m2SIdalmVoE" }, 
  { type: "image", src: "/assets/synnergise/2.jpg" },
    { type: "image", src: "/assets/synnergise/3.jpg" },
    { type: "image", src: "/assets/synnergise/16.jpg" },
    { type: "image", src: "/assets/synnergise/19.jpg" },
    { type: "image", src: "/assets/synnergise/sincl.jpg" },
  ]
   const retreats = [
  {
    image: "/assets/innergise/cardi.jpg",
    date: "📅 14th Feb – 17th Feb 2026",
    place: " Sahaja Retreat, Rishikesh",
    price: "Starting from Rs 19,000 + Taxes",
    link:"/retreats/innergise/book-oct-retreat"
  },
];

  return (
    <>
        <div className="w-full text-center p-8 md:p-10 bg-light">
          <h1 className="text-2xl md:text-4xl  font-bold text-[#8B2218] leading-tight">
            INNERGISE RETREAT
          </h1>
          <h2 className="text-lg md:text-2xl  text-[#578d48] font-bold mt-4 md:mt-14">
          🌿 Rejuvenate, Reconnect, and Rediscover Yourself 
          in the Himalayas
          </h2></div>
         <section className="py-10 px-6 md:px-20 flex flex-col gap-6 bg-light items-center">
      <h2 className="text-2xl md:text-3xl font-bold text-secondary">Upcoming Retreats</h2>
      {retreats.map((retreat, index) => (
        <RetreatCard key={index} {...retreat} />
      ))}
    </section>
    <Header
       description={[
        "4 Transforming Days in Rishikesh - Starting from Rs. 19,000+ Taxes",
        "Yoga, Meditation, Mind Recharge, Nature Connect & more!",
        "Led by IITian turned Holistic Wellness & Mindset Coach",
      ]}
       
    
      mainImage="/assets/_DSC1537.jpg"
      sideImages={["/assets/yog.jpg", "/assets/yog2.jpg"]} 
      mediaItems={mediaItems} 
      showVideo={true} 
      icons={icons}
   
    />
            {/* Button */}
            <div className="bg-gradient-to-r  from-gray-100 to-gray-50 text-center items-center">
  <Button onClick={details} text="View More Details" className="md:mb-5 mb-3" variant="primary" size="md" />
  </div>
  
<section className="md:py-8 py-6 bg-[#F1E5D9]">
        <div className="container mx-auto px-4">
          <DynamicVideoCarousel
            heading="Impact Stories"
            videos={testimonalVideos}
          />
        </div>
      </section>
      <TransformSection ref={detailsRef} imageSrc={transformImage} altText="Transformation experience" heading={transformHeading} paragraph={transformParagraph} points={transformPoints} ticons={ticons} />
       
              <div className="flex justify-center mt-4 mb-4">
          <a href="/retreats/innergise/book-oct-retreat" >
            <Button text="Reserve Your Spot" variant="primary" size="md" />
          </a>
        </div>

             <BannerSection heading={heading}  features={features} bannerp={bannerp} />

     
      
 
  <section className="py-8 bg-[#F1E5D9] align-center text-center text-sm md:text-lg  items-center">
<button onClick={() => navigate('/retreat-inquiry-form')}  className="text-secondary hover:text-primary underline cursor-pointer font-semibold">
  
  📞 Have questions? Request a call back
</button>

</section>
<div className="fixed bottom-0 w-full bg-primary text-white py-1 px-4 md:py-2 text-center shadow-lg z-50">
  <Button 
     onClick={() => navigate('/retreats/innergise/book-oct-retreat')} text="Sign up now"
    className="mt-2  " variant="whitish" size="sm"
  />
  </div>

    </>
  );
};

export default HomePage;
